import { useEffect, useRef, useContext } from 'react'
import { UUID } from "uuidjs";
import useClient from './useClient'
import { OrderEngineContext } from '../contexts/OrderEngineContext'

export default function useOrders(options = {}) {
  const { cbPrintOrderSlips = null, cbPrintOrderStornoSlips = null, cbPrintOrderItemStornoSlips = null, cbOrderExternalOrderNumberReceived = null } = options
  const { orders, addOrderStatus, addOrderItemStatus, setOrderTable, removeClosedOrder } = useContext(OrderEngineContext)
  const { client } = useClient()
  const uid = useRef(UUID.generate())

  const onOrderExternalOrderNumberReceived = ({ orderUUID, externalOrderNumber }) => {
    //console.log('onOrderExternalOrderNumberReceived', orderUUID, externalOrderNumber)
    if (typeof cbOrderExternalOrderNumberReceived === 'function') {
      cbOrderExternalOrderNumberReceived(orderUUID, externalOrderNumber)
    }
  }

  const onOrderPrintSlips = (orderObj) => {
    if (typeof cbPrintOrderSlips === 'function') {
      cbPrintOrderSlips(orderObj)
    }
  }

  const onOrderPrintStornoSlips = (orderObj) => {
    if (typeof cbPrintOrderStornoSlips === 'function') {
      cbPrintOrderStornoSlips(orderObj)
    }
  }

  const onOrderItemStornoPrintSlips = ({ orderUUID, orderItemUUID }) => {
    if (typeof cbPrintOrderItemStornoSlips === 'function') {
      cbPrintOrderItemStornoSlips(orderUUID, orderItemUUID)
    }
  }

  const distributeDiscountAmount = async (orderItemList, discountID, discountAmount) => {
    return await client.orders.discounts.distributeDiscountAmount(orderItemList, discountID, discountAmount)
  }

  useEffect(() => {
    if (client) {
      client.orders.addCallback('onOrderPrintSlips', uid.current, onOrderPrintSlips)
      client.orders.addCallback('onOrderPrintStornoSlips', uid.current, onOrderPrintStornoSlips)
      client.orders.addCallback('onOrderItemStornoPrintSlips', uid.current, onOrderItemStornoPrintSlips)
      client.orders.addCallback('onOrderExternalOrderNumberReceived', uid.current, onOrderExternalOrderNumberReceived)
    }
    return () => {
      // ON UNMOUNT
      if (client != null) {
        client.orders.removeCallback('onOrderPrintSlips', uid.current)
        client.orders.removeCallback('onOrderPrintStornoSlips', uid.current)
        client.orders.removeCallback('onOrderItemStornoPrintSlips', uid.current)
        client.orders.removeCallback('onOrderExternalOrderNumberReceived', uid.current)
      }
    }
  }, [client])

  return {
    orders,
    client,
    addOrderStatus,
    addOrderItemStatus,
    setOrderTable,
    removeClosedOrder,
    distributeDiscountAmount
  }
}
